import { IDefaultLogo } from "../interfaces/logo.interface";
import IMAGES from "./images";

export const LOGOS: { driver: IDefaultLogo[] } = {
    driver:[{
        type: 'purple',
        color: '#6C8EEF',
        background: '#DFE7FF',
        url: IMAGES.driver.purple,
    },
    {
        type: 'blue',
        color: '#3883FF',
        background: '#C0D8FF',
        url: IMAGES.driver.blue,
    },
    {
        type: 'yellow',
        color: '#FFD875',
        background: '#FBF4DB',
        url: IMAGES.driver.yellow,
    },
    ]
}